__turbopack_context__.v({
  "className": "roboto_bda2ce68-module__Qzftwq__className",
  "variable": "roboto_bda2ce68-module__Qzftwq__variable",
});
